import { HttpErrorResponse } from '@angular/common/http';

export function extractProblemDetail(err: unknown): string | null {
    if (!(err instanceof HttpErrorResponse)) {
        return null;
    }
    const body = err.error;
    if (typeof body === 'object' && body !== null && typeof (body as { detail?: unknown }).detail === 'string') {
        return (body as { detail: string }).detail;
    }
    return null;
}
